import { render, staticRenderFns } from "./disclaimers.vue?vue&type=template&id=d7d8603e&scoped=true"
import script from "./disclaimers.vue?vue&type=script&lang=js"
export * from "./disclaimers.vue?vue&type=script&lang=js"
import style0 from "./disclaimers.vue?vue&type=style&index=0&id=d7d8603e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7d8603e",
  null
  
)

export default component.exports